<template>
  <div class="w-full rounded-md bg-secondary p-3">
    <div class="mb-2 flex flex-row items-center gap-2 py-1">
      <StatusBadge :color="status.color" :text="status.label" />
      <VolumeChecked :total-checked="shipping.totalAttestedItems" :volume="shipping.totalItems" />

      <div class="flex flex-grow flex-row items-center justify-between">
        <IconWrapper v-if="shipping.isGrouped" backgroundColor="#2884EF">
          <IconStack3Filled class="text-on-primary" />
        </IconWrapper>

        <IconWrapper backgroundColor="#616161">
          <IconChevronRight class="text-primary" stroke="4" />
        </IconWrapper>
      </div>
    </div>

    <div class="flex flex-row">
      <div class="flex w-1/2 flex-col gap-3">
        <div class="shipping-detail">
          <p>DATA</p>
          <p>{{ invoiceDate }}</p>
        </div>

        <div class="shipping-detail">
          <p>TOTAL DE ITENS</p>
          <p>{{ shipping.totalItems }}</p>
        </div>
      </div>

      <div class="flex w-1/2 flex-col gap-3">
        <div class="shipping-detail">
          <p>TRANSPORTADORA</p>
          <p>{{ shipping.carrier }}</p>
        </div>

        <div class="shipping-detail">
          <p>QTD NOTAS FISCAIS</p>
          <p>{{ shipping.shippingReceiptQuantity }}</p>
        </div>
      </div>
    </div>

    <VButton
      v-if="
        shipping.totalAttestedItems === shipping.totalItems && status.label !== EStatus.RELEASED
      "
      class="mt-4 p-2"
      :disabled="false"
      type="solid"
      title="Liberar carga"
      :callback="handleRelease"
    />
  </div>
</template>

<script setup lang="ts">
import StatusBadge from '@/components/StatusBadge/StatusBadge.vue'
import VolumeChecked from '@/components/VolumeChecked/VolumeChecked.vue'
import { STATUS_COLOR } from '@/constraints'
import { EStatus } from '@/enums'
import type { ShippingStatus } from '@/services/WarrantyApiService/types'
import { useDateTime } from '@/value-objects/date-time'
import { IconChevronRight, IconStack3Filled } from '@tabler/icons-vue'
import { computed } from 'vue'
import VButton from '../Button/VButton.vue'
import IconWrapper from '../IconWrapper/IconWrapper.vue'

const datetime = useDateTime()
const emit = defineEmits(['release'])
type Props = {
  shipping: {
    id: string
    carrier: string
    invoiceDate: Date
    totalItems: number
    shippingReceiptQuantity: number
    status: ShippingStatus
    totalAttestedItems: number
    isGrouped: boolean
  }
}

const { shipping } = defineProps<Props>()

const invoiceDate = computed(() => datetime.format(shipping.invoiceDate, 'dd/MM/yyyy'))

const status = computed(() => {
  return {
    label: EStatus[shipping.status],
    color: STATUS_COLOR[EStatus[shipping.status]]
  }
})

async function handleRelease() {
  emit('release', shipping.id)
}
</script>

<style lang="postcss" scoped>
.shipping-detail {
  @apply flex flex-col gap-1;
  @apply text-xs font-semibold;

  p:first-child {
    @apply text-primary;
  }

  p:last-child {
    @apply text-white;
  }
}
</style>
